module.exports = __webpack_public_path__ + "static/media/truck5.52dda597.jpg";